import {Flex, Progress, Stack} from "@chakra-ui/react";
import React, {useEffect, useState} from "react";
import Accounts from "./Components/Accounts";
import Gegevens from "./Components/Gegevens";
import Buttons from "./Components/Buttons";
import Header from "./Components/Header";
import PremiumAccount from "./Components/PremiumAccount";
import {getUser} from "../../../api/userService";
import LoadingData from "../../../components/Loading/LoadingData";

function Settings() {
  const [isLoadingUserData, setIsLoadingUserData] = useState(true);
  const [userData, setUserData] = useState({
    firstName: "",
    lastName: ""
  });

  const fetchUserData = async () => {
    try {
      const response = await getUser();
      setUserData({
        email: response.email,
        firstName: response.firstName === null ? "" : response.firstName,
        lastName: response.lastName === null ? "" : response.lastName,
        hasSubscription: response.hasSubscription === null ? false : response.hasSubscription,
        createdAt: response.createdAt === null ? "" : response.createdAt
      });
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoadingUserData(false);
    }
  };

  useEffect(() => {
    const response = fetchUserData();
  }, []);


  return (
    <Flex direction="column" pt={{sm: "125px", lg: "75px"}}>
      <Buttons/>
      <Stack
        direction="column"
        spacing="24px"
        mt="40px"
        align={{lg: "flex-end"}}
        justify={{lg: "flex-end"}}
        w="100%"
      >
        {
          isLoadingUserData ? (
            <LoadingData/>
          ) : (
            <>
              <Header firstName={userData.firstName} lastName={userData.lastName} email={userData.email}
                      hasSubscribed={userData.hasSubscription}/>
              <Gegevens initialFirstName={userData.firstName} initialLastName={userData.lastName}
                        initialEmail={userData.email} onRefresh={fetchUserData}/>
              {/*<ChangePassword/>*/}
              {/*<TwoFactorAuth/>*/}
              {/*<Accounts/>*/}
              {/*<Notifications/>*/}
              {/*<Sessions/>*/}
              <PremiumAccount hasSubscribed={userData.hasSubscription} onRefresh={fetchUserData}/>
            </>
          )
        }

      </Stack>
    </Flex>
  );
}

export default Settings;
